export default __webpack_public_path__ + "f7f237f0e8899667039bedf96b76d9c3.svg";